/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_AmbiguousInputs */

const en_issue_ambiguous = /** @type {(inputs: Issue_AmbiguousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`names more than one: use its code`)
};

/**
* | output |
* | --- |
* | "names more than one: use its code" |
*
* @param {Issue_AmbiguousInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_ambiguous = /** @type {((inputs?: Issue_AmbiguousInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_AmbiguousInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_ambiguous(inputs)
});